export const CommonActionType = {
    SetExchangeRate: '[Common] Set Exchange Rate',
    SetMinFeeBuy: '[Common] Set Min FeeBuy',
    FeeBuyPro: '[Common] Set Fee Buy Pro',
    SetCustomerLevels: '[Common] Set Customer Levels',
    SetProductTypes: '[Common] Set Product Types',
    SetWarehouse: '[Common] Set Warehouse',
    SetChinaStore: '[Common] Set ChinaStore',
    SetChinaAddress: '[Common] Set ChinaAddress',
    SetFeeGuarantee: '[Common] Set FeeGuarantee',
    ShowHideMenuLeft: '[Common] Show hide menu left'
};

